<!-- FAQ -->
<section class="py-20 bg-gray-50 dark:bg-slate-900" id="faq">
  <div class="max-w-4xl mx-auto px-4">
    <div class="text-center mb-16 scroll-fade-in">
      <h2 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
        Questions fréquentes
      </h2>
      <p class="text-xl text-gray-600 dark:text-gray-400">
        Tout ce que tu dois savoir
      </p>
    </div>

    <div class="space-y-6">
      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          Comment ça marche concrètement ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Tu crées ton événement (date, lieu, type), on récupère la météo
          automatiquement, et notre IA calcule les quantités optimales par
          produit. Tu reçois une liste de préparation que tu peux imprimer ou
          consulter sur ton téléphone.
        </p>
      </details>

      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          L'essai gratuit est-il vraiment sans CB ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Oui, 100% sans carte bancaire. Tu peux tester toutes les
          fonctionnalités, sans limite, pendant 1 mois (non renouvelable). Si tu
          es convaincu, tu pourras ajouter ton moyen de paiement à la fin de
          l'essai. Une fois abonné, tu peux aussi mettre ton abonnement en pause
          sans perdre ton historique ni tes données.
        </p>
      </details>

      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          Comment l'IA devient-elle plus précise avec le temps ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Après chaque événement, tu saisis rapidement tes ventes réelles.
          L'algorithme compare tes quantités vendues aux recommandations et
          ajuste ses prédictions futures. Plus tu utilises l'app, plus elle
          devient précise pour TON activité spécifique.
        </p>
      </details>

      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          Ça marche pour tous types de produits ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Oui ! Food trucks, stands boissons, boulangers, glaciers, artisans.
          L'app s'adapte à ton type d'activité et tes produits spécifiques. Tu
          peux gérer aussi bien des burgers que des glaces artisanales.
        </p>
      </details>

      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          Que se passe-t-il si je n'ai aucun historique ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Pas de problème ! On utilise des profils par défaut basés sur des
          milliers de données d'autres vendeurs dans ton secteur. Dès ton 1er
          événement, l'app commence à apprendre de TON activité.
        </p>
      </details>

      <details
        class="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-md dark:shadow-slate-900/50 scroll-fade-in group"
      >
        <summary
          class="font-bold text-lg text-gray-900 dark:text-white cursor-pointer flex justify-between items-center"
        >
          Puis-je annuler mon abonnement facilement ?
          <svg
            class="w-6 h-6 text-purple-600 transform group-open:rotate-180 transition"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>
        <p class="mt-4 text-gray-600 dark:text-gray-400">
          Bien sûr, tu peux annuler en 1 clic depuis ton compte, à tout moment.
          Pas de frais cachés, pas de période d'engagement. Tu conserves l'accès
          jusqu'à la fin de ton mois payé.
        </p>
      </details>
    </div>
  </div>
</section>

<!-- Final CTA -->
<section class="py-20 bg-gradient-to-r from-purple-600 to-purple-700">
  <div class="max-w-4xl mx-auto px-4 text-center text-white">
    <h2 class="text-4xl md:text-5xl font-bold mb-6">
      Prêt à arrêter de jeter et gagner plus ?
    </h2>
    <p class="text-xl mb-8 text-purple-100">
      Rejoins les 500+ vendeurs qui optimisent leurs stocks avec Predivent
    </p>

    <div class="flex flex-col sm:flex-row gap-4 justify-center mb-8">
      <a
        href="#"
        class="bg-white dark:bg-slate-800 text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 transition shadow-xl dark:shadow-slate-900/60 hover:shadow-2xl transform hover:-translate-y-1"
      >
        🚀 Essai gratuit 1 mois
      </a>
      <a
        href="#"
        class="bg-purple-800/50 backdrop-blur-sm text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-purple-800/70 transition border-2 border-white/30"
      >
        💬 Parler à un expert
      </a>
    </div>

    <div class="flex items-center justify-center gap-6 text-sm text-purple-100">
      <div>✓ Sans CB</div>
      <div>✓ Setup en 5 min</div>
      <div>✓ Support 7j/7</div>
    </div>
  </div>
</section>
